import { adminAPIService } from './index'

const route = 'home-collections'

export default {
  getCollection: (slug) => {
    const params = {
      country: 'HK',
    }
    return adminAPIService({
      url: `${route}/${slug}`,
      method: 'get',
      params,
    })
  },
  updateCollections: (collection, slug) => {
    const body = `country=HK&json=${encodeURIComponent(JSON.stringify(collection))}`
    return adminAPIService({
      url: `${route}/${slug}`,
      method: 'post',
      data: body,
    })
  },
}
